/**
 * Simplified column definitions for payment confirmation modal grid
 * Shows only critical milestone information
 */

import { formatAccountingAmount } from "../utils/formatters";

export const modalGridColDefs = [
  {
    headerName: "Milestone Name",
    field: "name",
    valueGetter: (params: any) => {
      return params.data?.name || params.data?.title || "Unnamed Milestone";
    },
    minWidth: 200,
    flex: 1,
    sortable: false,
    filter: false,
    resizable: true,
  },
  {
    headerName: "Creator",
    field: "user_id.name",
    valueGetter: (params: any) => {
      return params.data?.user_id?.name || "Unknown Creator";
    },
    minWidth: 150,
    flex: 1,
    sortable: false,
    filter: false,
    resizable: true,
  },
  {
    headerName: "Brand",
    field: "brand_id.name",
    valueGetter: (params: any) => {
      return params.data?.brand_id?.name || "Unknown Brand";
    },
    minWidth: 120,
    flex: 1,
    sortable: false,
    filter: false,
    resizable: true,
  },
  {
    headerName: "Campaign",
    field: "campaign_id.name",
    valueGetter: (params: any) => {
      return params.data?.campaign_id?.name || "Unknown Campaign";
    },
    minWidth: 150,
    flex: 1,
    sortable: false,
    filter: false,
    resizable: true,
  },
  {
    headerName: "Amount",
    field: "amount",
    valueGetter: (params: any) => {
      const amount = Number(params.data?.holdBalance ?? params.data?.rate ?? 0);
      return Number.isFinite(amount) ? amount : 0;
    },
    valueFormatter: (params: any) => {
      return formatAccountingAmount(params.value);
    },
    minWidth: 100,
    width: 100,
    sortable: false,
    filter: false,
    resizable: true,
    cellClass: "text-end",
  },
];
